export default {

    all: state => Object.values(state.entities),

    allByCompanyId: (state, getters) => companyId => {
        return getters['all'].filter(campaign => campaign.company === companyId)
    },

    byId: state => id => {
        return state.entities[id]
    },

    counts: state => state.counts,

}


